import { Suspense, lazy, memo, useCallback } from "react";
import { useSelector } from "react-redux";

import { AsyncDataSuspense } from "@tsp-core/async/components/async-data-suspense";

import { countriesApi } from "@tsp-domains/countries/api";
import { partiesApi } from "@tsp-domains/parties/api";

import { Access } from "../../features/auth/components";
import { Layout } from "../../features/layout";
import { UserStateData, selectUserData } from "../../features/user";

const Content = lazy(() => import("./settings.content"));

const checkAccess = (user: UserStateData) => user.authenticated;

function SettingsPage() {
  const data = useSelector(selectUserData);

  const [triggerGetCountriesDictionary, getCountriesDictionaryQuery] =
    countriesApi.useLazyGetCountriesDictionaryQuery();
  const [triggerGetPartyDetails, getPartyDetailsQuery] = partiesApi.useLazyGetPartyDetailsQuery();

  const onAccessHandler = useCallback(() => {
    triggerGetCountriesDictionary();
    triggerGetPartyDetails(data.party.uuid);
  }, [triggerGetCountriesDictionary, triggerGetPartyDetails, data]);

  return (
    <Access checkAccess={checkAccess} onAccess={onAccessHandler}>
      <AsyncDataSuspense queries={[getCountriesDictionaryQuery, getPartyDetailsQuery]}>
        <Layout loading={false}>
          <Suspense fallback={null}>
            {getPartyDetailsQuery.data && (
              <Content name={getPartyDetailsQuery.data.name} companyUuid={getPartyDetailsQuery.data.companyUuid} />
            )}
          </Suspense>
        </Layout>
      </AsyncDataSuspense>
    </Access>
  );
}

export default memo(SettingsPage);
